export const DateFormat = {
  default: 'MM/DD/YYYY',
  defaultTime: 'hh:mm A',
  DATE_TIME: 'M/dd/yy - hh:mm a',
  DATE_TIME_YYYY_MM_DD_HH_MM_a: 'MM/DD/YYYY - hh:mm A',
};

export const Constants = {
  SEARCH_HISTORY_LIMIT: 20,
};

export const Platform = {
  SVInspect: 'inspi2',
};

export enum Permissions {
  CAN_AI_AUDIT = 'SPINEXT:Audit:Ai',
  CAN_SEARCH_WORK_ORDER = 'SPINEXT:Search:ByOrderNumber',
  CAN_VIEW_SUBMISSIONS = 'SPINEXT:Submission:Read',
  CAN_VIEW_AUDIT_RESULTS_BY_ID = 'SPINEXT:CoreScriptApi:AuditResultsBySubmissionId:Read',
  CAN_VIEW_LANGUAGE_PACK = 'SPINEXT:LanguagePack:Read',
  CAN_VIEW_WORKORDER_LITE_LUGGAGE = 'SPINEXT:WorkOrder:OrderLiteLuggage',
  IS_INSPECTOR = 'SPINEXT:SVVendor:AccessAllowed',
  CAN_VIEW_AUDIT = 'SPINEXT:Audit:Read',
  CAN_ACCESS_PROMPT_LIBRARY = 'SPINEXT:PromptLibrary:AccessAllowed',
  HAS_CORESCRIPT_SAVE = 'SPINEXT:CoreScriptApi:INSPI:Save',
  HAS_CORESCRIPT_AuditResults_SAVE = 'SPINEXT:CoreScriptApi:AuditResults:Save',
}

export const contextValue = {
  AuditResultsBySubmissionId: 'AuditResultsBySubmissionId',
  AuditResults: 'AuditResults',
  AuditRequest: 'AuditRequest', //Manual Results
  CodeViolation: 'CodeViolation',
  ConveyImpediments: 'ConveyImpediments',
  INSPI: 'INSPI',
  ICCStatusRequest: 'ICCStatusRequest',
  ICCConfirmationRequest: 'ICCConfirmationRequest',
  OrderRequest: 'OrderRequest',
  OrderModificationRequest: 'OrderModificationRequest',
  OrderRequestVendorReassignRequest: 'OrderRequestVendorReassignRequest',
  PostAuditRequest: 'PostAuditRequest',
  PropertyRequest: 'PropertyRequest',
  ReconveyRequest: 'ReconveyRequest',
  SACC: 'SACC',
  ScheduleScriptRequest: 'ScheduleScriptRequest',
  TextRequest: 'TextRequest',
  VendorTextRequest: 'VendorTextRequest',
};
export const contextReadOnly: Record<string, boolean> = {
  AuditResultsBySubmissionId: true,
  AuditResults: false,
  AuditRequest: false, //Manual Results
  CodeViolation: false,
  ConveyImpediments: false,
  INSPI: false,
  ICCStatusRequest: false,
  ICCConfirmationRequest: false,
  OrderRequest: false,
  OrderModificationRequest: false,
  OrderRequestVendorReassignRequest: false,
  PostAuditRequest: false,
  PropertyRequest: false,
  ReconveyRequest: false,
  SACC: false,
  ScheduleScriptRequest: false,
  TextRequest: false,
  VendorTextRequest: false,
};

export const contextSidePanelNotSupported: Record<string, boolean> = {
  AuditResultsBySubmissionId: true,
  AuditResults: true,
  AuditRequest: true, //Manual Results
};

export const contextSupportGallery: Record<string, boolean> = {
  AuditResultsBySubmissionId: true,
  AuditResults: true,
  AuditRequest: true, //Manual Results
  CodeViolation: false,
  ConveyImpediments: false,
  INSPI: true,
  ICCStatusRequest: false,
  ICCConfirmationRequest: false,
  OrderRequest: false,
  OrderModificationRequest: false,
  OrderRequestVendorReassignRequest: false,
  PostAuditRequest: true,
  PropertyRequest: false,
  ReconveyRequest: false,
  SACC: false,
  ScheduleScriptRequest: false,
  TextRequest: false,
  VendorTextRequest: false,
};

export const contextReturnAddedContextID: Record<string, boolean> = {
  PropertyRequest: true,
};
export const contextPostMessageBack: Record<string, boolean> = {
  AuditResultsBySubmissionId: false,
  AuditResults: true,
  AuditRequest: true, //Manual Results
  CodeViolation: true,
  ConveyImpediments: true,
  INSPI: true,
  ICCStatusRequest: true,
  ICCConfirmationRequest: true,
  OrderRequest: true,
  OrderModificationRequest: true,
  OrderRequestVendorReassignRequest: true,
  PostAuditRequest: true,
  PropertyRequest: true,
  ReconveyRequest: true,
  SACC: true,
  ScheduleScriptRequest: true,
  TextRequest: true,
  VendorTextRequest: true,
};

export const ImageStatus = {
  IMAGE_STATE_UPLOADED: 'IMAGE_STATE_UPLOADED',
  IMAGE_STATE_CREATED: 'IMAGE_STATE_CREATED',
  IMAGE_STATE_SUCCESS: 'IMAGE_STATE_SUCCESS',
  IMAGE_STATE_REJECT: 'IMAGE_STATE_REJECT',
  IMAGE_STATE_FAIL: 'IMAGE_STATE_FAIL',
};

export const FILE_UPLOAD_STATUS = {
  SUCCESS: 'success', //Alt status from mediav2
  UPLOADING: 'uploading',
  PENDING: 'pending',
  FAILED: 'failed',
  UPLOADED: 'uploaded', //Alt status from mediav2
  REJECTED: 'rejected', //Alt status from mediav2
  CREATED: 'created', //Alt status from mediav2
} as const;
